import { render, staticRenderFns } from "./role-manag.vue?vue&type=template&id=30b46e7d"
import script from "./role-manag.vue?vue&type=script&lang=js"
export * from "./role-manag.vue?vue&type=script&lang=js"
import style0 from "./role-manag.vue?vue&type=style&index=0&id=30b46e7d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports